import useStepperState from './useStepperState';

const useStepState = id => {
  if (id == null) {
    throw new Error('Id in `useStepState` must not be null');
  }

  const stepperState = useStepperState();

  return {
    ...stepperState.steps.get(id),
    isCurrentStep:
      [...stepperState.steps.keys()][stepperState.currentStep] === id,
  };
};

export default useStepState;
